export const pendingCustomerHeading = [
    {
        "fullName": "NAME",
        "phoneNumber": "PHONE",
        "status": 'STATUS',
        "eligibleCreditAmount": 'AVAILABLE CREDIT AMOUNT',
        "updatedAt": 'LAST UPDATED',
        "action": 'ACTION',
    },
];
